export const COUNTRY_VALIDATION_REG_EXS = {
    'AT': /^ATU\d{8}$/,
    'BE': /^BE\d{10}$/,
    'BG': /^BG(\d{9}|\d{10})$/,
    'CY': /^CY\d{8}[A-Za-z]$/,
    'CZ': /^CZ(\d{8}|\d{9}|\d{10})$/,
    'DK': /^DK\d{8}$/,
    'GR': /^EL\d{9}$/,
    'EL': /^EL\d{9}$/,
    'EE': /^EE\d{9}$/,
    'ES': /^ES[A-Za-z\d]{2}\d{5}[A-Za-z\d]{2}$/,
    'FI': /^FI\d{8}$/,
    'FR': /^FR[A-HJ-NP-Za-hj-np-z\d]{2}\d{9}$/,
    'HR': /^HR\d{11}$/,
    'HU': /^HU\d{8}$/,
    'IE': /^IE\d[A-Za-z\d]\d{4,5}[A-Za-z\d]{2}$/,
    'IT': /^IT\d{11}$/,
    'LT': /^LT(\d{9} | \d{12})$/,
    'LU': /^LU\d{8}$/,
    'LV': /^LV\d{11}$/,
    'MT': /^MT\d{8}$/,
    'NL': /^NP\d{12}$/,
    'PL': /^PL\d{10}$/,
    'PT': /^PT\d{9}$/,
    'RO': /^RO\d{10}$/,
    'SE': /^SE\d{12}$/,
    'SI': /^SI\d{8}$/,
    'SK': /^SK\d{10}$/,
};

const validator = {
    validateEmail: (email: string): boolean => {
        const re =
            /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[\d{1,3}\.\d{1,3}\.\d{1,3}\.\d{1,3}\])|(([a-zA-Z\-\d]+\.)+[a-zA-Z]{2,}))$/;

        return re.test(email);
    },
    validateUrl: (url: string): boolean => {
        const re =
            /^(https?:\/\/)?([\w\-]+(\.[\w\-]+)+)(:\d+)?(\/\S*)?$/;

        return re.test(url);
    },
    validateVATId: (id: string | undefined, countryCode: string, isRequired = false): boolean => {
        if (!id && !isRequired) {
            return true;
        }

        const re = COUNTRY_VALIDATION_REG_EXS[countryCode.toUpperCase()];

        return re?.test(id);
    }
};

export default validator;
